import { TableColumn } from "@/hooks/useTableColumns";

// TODO: proper types
export const exportTable = <T extends Record<string, any>>(
	columns: TableColumn[],
	results: T[],
	getterOverrides: Record<string, (item: T) => any>,
	name = "export.csv"
) => {
	const enabledColumns = columns.filter(column => column.enabled);

	const header = enabledColumns.map(column => column.title);

	const rows = results.map(result => {
		const row = [];
		for (const column of enabledColumns) {
			if (column.value in getterOverrides) {
				row.push(getterOverrides[column.value](result));
			} else {
				row.push(result[column.value]);
			}
		}
		return row;
	}) as string[][];
	rows.reverse(); // rows are displayed in reverse order

	const csvContent = [header, ...rows].map(row => row.join(",")).join("\n");

	const blob = new Blob([csvContent], {
		type: "text/csv;charset=utf-8;",
	});
	const url = URL.createObjectURL(blob);

	const link = document.createElement("a");
	link.style.display = "none";
	link.setAttribute("href", url);
	link.setAttribute("download", name);

	document.body.appendChild(link); // required for Firefox
	link.click();
	document.body.removeChild(link);

	URL.revokeObjectURL(url);
};
